import { render, staticRenderFns } from "./purchDetail.vue?vue&type=template&id=069a6c36"
import script from "./purchDetail.vue?vue&type=script&lang=js"
export * from "./purchDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports